import { put } from "redux-saga/effects";
import { registerFone } from "../../Services";

export function* registerFoneSaga(action) {
  const payload = action.payload;
  try {
    const res = yield registerFone(payload);

    yield put({ type: "REQ_REGISTER_FONE_SUCCESS", data: res.data });
  } catch (error) {
    console.log("error register", error.message);
    yield put({ type: "REQ_REGISTER_FONE_FAILED", data: error.message });
  }
}
